/* eslint-disable no-undef */

const openAccordion = (accordion, header, panel) => {
  accordion.classList.add('is-active');
  header.setAttribute('aria-expanded', 'true');
  panel.setAttribute('aria-hidden', 'false');
};

const closeAccordion = (accordion, header, panel) => {
  accordion.classList.remove('is-active');
  header.setAttribute('aria-expanded', 'false');
  panel.setAttribute('aria-hidden', 'true');
};

const handleAccordionDisplay = (accordion, header, panel) => {
  if (accordion.classList.contains('is-active') === true) {
    closeAccordion(accordion, header, panel);
  } else {
    openAccordion(accordion, header, panel);
  }
};

const setupA11y = (index, header, panel) => {
  const headerID = `ft-accordion-header-${index}`;
  const panelID = `ft-accordion-panel-${index}`;

  header.setAttribute('id', headerID);
  header.setAttribute('aria-expanded', 'false');
  header.setAttribute('aria-controls', panelID);

  panel.setAttribute('id', panelID);
  panel.setAttribute('aria-hidden', 'true');
  panel.setAttribute('aria-labelledby', headerID);
};

const bindListeners = (accordion, header, panel) => {
  // Click listener
  accordion.addEventListener('click', (e) => {
    if (e.target === header) {
      handleAccordionDisplay(accordion, header, panel);
    }
  });
};

const init = () => {
  const accordions = document.querySelectorAll('.ft-accordion');

  if (accordions.length === 0) {
    return;
  }

  accordions.forEach((accordion, index) => {
    const header = accordion.querySelector('.ft-accordion__header');
    const panel = accordion.querySelector('.ft-accordion__content');

    // Setup A11y
    setupA11y(index, header, panel);

    // Bind Listeners
    bindListeners(accordion, header, panel);
  });
};

export default init;
